/**
 * This file will contain utility functions related to Handsontable instance data manipulation.
 */

// Types
import { TableContentData } from '../../../../../common/table/TableTypes';
import { CellProperties } from 'handsontable/settings';
import { set } from 'lodash';
import { MNHotInstance } from '../../tableHotInstanceTypes';

/**
 * Builds a dense table data array from HOT cell metadata up to the provided bounds.
 */
const buildTableContentData = (cellMetas: CellProperties[], toRow: number, toCol: number): TableContentData => {
    const data: TableContentData = [];

    cellMetas.forEach((cellMeta) => {
        const { row, col, cellData } = cellMeta || {};
        if (cellData && row < toRow && col < toCol) set(data, [row, col], cellData);
    });

    return data;
};

/**
 * Returns all the cell data via the HoT instance.
 */
export const buildHotTableContentData = (hotInstance: MNHotInstance): TableContentData => {
    const cellMetas = hotInstance.getCellsMeta();
    const rowCount = hotInstance.countRows();
    const colCount = hotInstance.countCols();

    return buildTableContentData(cellMetas, rowCount, colCount);
};
